module.exports = ".checkbox label, .radio label {\n  padding-left: 0px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/login/login.component.scss
// module id = ./src/app/login/login.component.scss
// module chunks = main